module.exports = __webpack_public_path__ + "static/media/60pic.6e51e027.jpg";